import { create } from 'zustand';

export interface RadarSpeciesDto {
    speciesId: number;
    speciesCode: string;
    scientificName: string;
    primaryCommonName: string;
    translations: Record<string, string>;
    themeColors: string[];
    topPhotos: RadarFlickrPhotoDto[];
    topSounds: RadarSoundDto[];
    sightings: ObservationLocationDto[];
}

export interface ObservationLocationDto {
    latitude: number;
    longitude: number;
    locationName: string;
    observationDate: string;
    howMany: number;
}

export interface RadarFlickrPhotoDto {
    photoId: string;
    imageUrl: string;
    ownerName: string;
}

export interface RadarSoundDto {
    id: number;
    xenoCantoId: number;
    soundType: string;
    audioUrl: string;
    recordistUrl: string;
    quality: string;
}

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5188/api/v1";

interface BirdRadarState {
    currentLat: number | null;
    currentLng: number | null;
    radiusKm: number;
    language: string;
    surroundingBirds: RadarSpeciesDto[];
    isLoading: boolean;
    setLocation: (lat: number, lng: number) => void;
    setRadiusKm: (km: number) => void;
    setLanguage: (lang: string) => void;
    fetchRadarData: () => Promise<void>;
}

export const useBirdRadarStore = create<BirdRadarState>((set, get) => ({
    currentLat: null,
    currentLng: null,
    radiusKm: 5,
    language: 'en',
    surroundingBirds: [],
    isLoading: false,

    setLocation: (lat, lng) => set({ currentLat: lat, currentLng: lng }),
    setRadiusKm: (km) => set({ radiusKm: km }),
    setLanguage: (lang) => set({ language: lang }),

    fetchRadarData: async () => {
        const { currentLat, currentLng, radiusKm } = get();
        if (!currentLat || !currentLng) return;

        set({ isLoading: true, surroundingBirds: [] });

        try {
            const res = await fetch(`${API_BASE}/radar/surroundings?lat=${currentLat}&lng=${currentLng}&radiusKm=${radiusKm}&daysAgo=14`);
            const data = await res.json();
            set({ surroundingBirds: data.species || [], isLoading: false });
        } catch (error) {
            console.error("Failed to fetch radar data", error);
            set({ isLoading: false });
        }
    }
}));
